import { refreshLoginStatus, chooseAccount, logout } from '@ad/uc';
import { RouterPath } from 'constants/constants';
import { history } from '../index';
import { getAccountAppId } from 'service/ad-user';
import { clearCookie } from './cookie';

export async function refreshPassToken() {
    // 更新凭证
    const { result } = await refreshLoginStatus();
    return result;
}

export async function systemLogout() {
    try {
        clearAccountId();
        // await sso.logout();
        const callbackUrl = `/rest/dsp/control-panel/agent/logout`;
        await logout(callbackUrl);
    } finally {
        const followUrl = `${encodeURIComponent(
            window.location.origin,
        )}/rest/dsp/control-panel/agent/logout`;
        window.location.href = `/rest/infra/logout?sid=kuaishou.ad.dsp&followUrl=${followUrl}`;
    }
}

/* accountId 携带逻辑 */
const __ACCOUNT_ID__ = '__accountId__';

export interface AccountInfo {
    accountId: string;
    accountName: string;
}

/**
 * 检查当前account是否正确
 * @param isKa 是否品牌用户
 */
export async function checkAccountInfo(isKa: boolean) {
    const account = getAccountId();
    const { appId } = await getAccountAppId(Number(account?.accountId));
    // 效果 && 携带品牌cookie
    if (appId === 1 && isKa) {
        console.warn('效果账户携带品牌cookie');
        clearCookie('agent_dsp_token');
        window.location.href = RouterPath.FRONT_PAGE;
    }
    // 品牌 && 不携带品牌cookie
    if (appId === 4 && !isKa) {
        console.warn('品牌账户未携带品牌cookie');
        window.location.href = `/rest/dsp/control-panel/brand/login?accountUcId=${account?.accountId}`;
    }
}

export function setUrlAccountId(accountId?: string) {
    const searchParser = new URLSearchParams(window.location.search);
    if (accountId !== undefined) {
        searchParser.set(__ACCOUNT_ID__, accountId);
    } else {
        searchParser.delete(__ACCOUNT_ID__);
    }
    const search = searchParser.toString();
    const path = window.location.pathname;
    const hash = window.location.hash;

    setTimeout(() => {
        history?.replace(`${path}?${search}${hash}`);
    }, 100);
}

export function setAccountId(accountInfo: AccountInfo) {
    localStorage.setItem(__ACCOUNT_ID__, JSON.stringify(accountInfo));
    setUrlAccountId(accountInfo.accountId);
}

export function getAccountId(): AccountInfo | undefined {
    const searchParser = new URLSearchParams(window.location.search);
    // url 附带的accountId
    const queryId = searchParser.get(__ACCOUNT_ID__);
    // localStorage 附带的accountId
    const storageInfo: AccountInfo | undefined = JSON.parse(localStorage.getItem(__ACCOUNT_ID__));

    if (queryId === storageInfo?.accountId) {
        return storageInfo;
    } else if (queryId || storageInfo) {
        const accountInfo = {
            accountId: queryId || storageInfo.accountId,
            accountName: storageInfo?.accountName,
        };
        // setUrlAccountId(accountInfo.accountId);
        return accountInfo;
    } else {
        return undefined;
    }
}

export function clearAccountId() {
    window.name = '';
    clearCookie('agent_dsp_token');
    localStorage.removeItem(__ACCOUNT_ID__);

    // setUrlAccountId();
}

export function switchAccount() {
    chooseAccount({ closeable: true });
    // clearAccountId();

    // window.location.href = '/account-compass?type=2';
}

interface UserInfo {
    userId: number;
    headUrl: string;
    userName: string;
    isKa?: boolean;
    accountUcId: number;
    accountUserId: number;
    agentUserId: number;
    adminUserId: number;
    kaAccountUcId: number;
    agentAccount: boolean;
    appId?: number;
    speedAuthorize?: any;
}

export function getJumpDspUrl(host: string, user: UserInfo, redirectPath?: string) {
    if (user.adminUserId || user.agentUserId) {
        const url = `${host}/rest/ad/login/multi-agency?adminUserId=${user.adminUserId}&agentUserId=${user.agentUserId}&accountUserId=${user.userId}&accountUcId=${user.accountUcId}`;
        return redirectPath ? `${url}&redirectPath=${encodeURIComponent(redirectPath)}` : url;
    }
    return host;
}

export function getJumpFangZhouUrl(host: string, user: UserInfo) {
    if (user.adminUserId || user.agentUserId) {
        return `${host}/rest/ad/agent/login?adminUserId=${user.adminUserId}&agentUserId=${user.agentUserId}&accountUserId=${user.userId}&accountUcId=${user.accountUcId}`;
    }
    return host;
}
